var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 2.04017V13.3989L5.063 10.8494C5.32896 10.6281 5.65941 10.5075 6 10.5075C6.34059 10.5075 6.67104 10.6281 6.937 10.8494L10 13.3978V2.04017H2ZM1.5 1H10.5C10.6326 1 10.7598 1.05479 10.8536 1.15233C10.9473 1.24987 11 1.38215 11 1.52009V14.4807C10.9999 14.5785 10.9732 14.6744 10.923 14.7572C10.8729 14.84 10.8013 14.9064 10.7165 14.9487C10.6317 14.9911 10.5371 15.0077 10.4436 14.9967C10.3501 14.9856 10.2615 14.9474 10.188 14.8863L6.312 11.6618C6.2234 11.5882 6.11338 11.5481 6 11.5481C5.88662 11.5481 5.7766 11.5882 5.688 11.6618L1.812 14.8863C1.73848 14.9474 1.64989 14.9856 1.5564 14.9967C1.46292 15.0077 1.36834 14.9911 1.28353 14.9487C1.19872 14.9064 1.12712 14.84 1.07697 14.7572C1.02681 14.6744 1.00013 14.5785 1 14.4807V1.52009C1 1.38215 1.05268 1.24987 1.14645 1.15233C1.24021 1.05479 1.36739 1 1.5 1Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.a7b9bad3a73126c27d8550e4b19d1ca1.svg";
export { ForwardRef as ReactComponent };